import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface NotFoundPageProps {
  onNavigate?: (path: string) => void;
}

export default function NotFoundPage({ onNavigate }: NotFoundPageProps) {
  return (
    <div className="flex items-center justify-center min-h-[80vh] px-4">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <AlertTriangle className="w-16 h-16 text-wiz-orange" />
        </div>
        <h1 className="text-7xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">Page Not Found</h2>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        {onNavigate && (
          <button
            onClick={() => onNavigate('/overview')}
            className="px-6 py-3 bg-[#325FE8] hover:bg-[#2850d0] text-white font-medium rounded-lg transition-colors"
          >
            Go to Overview
          </button>
        )}
      </div>
    </div>
  );
}
